import { styled, Button } from "@mui/material";
import { mapSizesIconContainer } from "./constants.js";
const StyledSquareButton = styled(Button)(
  ({ theme, size = "md" }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: mapSizesIconContainer[size],
    minWidth: mapSizesIconContainer[size],
    height: mapSizesIconContainer[size],
    padding: 0,
    svg: {
      width: "13.5px",
      height: "13.5px"
    },
    "&:active": {
      borderWidth: "2px"
    },
    "&.MuiButton-containedPrimary": {
      backgroundColor: theme.palette.primary[900],
      color: theme.palette.white.main,
      "&:hover": {
        backgroundColor: theme.palette.primary[800]
      },
      "&:active": {
        backgroundColor: theme.palette.primary[1e3]
      }
    },
    "&.MuiButton-outlinedPrimary": {
      backgroundColor: "transparent",
      color: theme.palette.primary[900],
      "&:hover": {
        color: theme.palette.primary[800]
      },
      "&:active": {
        color: theme.palette.primary[1e3]
      }
    },
    "&.MuiButton-containedSecondary": {
      backgroundColor: theme.palette.secondary[900],
      color: theme.palette.white.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary[800]
      },
      "&:active": {
        backgroundColor: theme.palette.secondary[1e3]
      }
    },
    "&.MuiButton-outlinedSecondary": {
      backgroundColor: "transparent",
      color: theme.palette.secondary[900],
      "&:hover": {
        color: theme.palette.secondary[800]
      },
      "&:active": {
        color: theme.palette.secondary[1e3]
      }
    },
    "&.MuiButton-containedInherit": {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.grey[800],
      "&:hover": {
        backgroundColor: theme.palette.grey[100]
      },
      "&:active": {
        backgroundColor: theme.palette.grey[200]
      }
    },
    "&.MuiButton-outlinedInherit": {
      backgroundColor: "transparent",
      color: theme.palette.white.main,
      "&:hover": {
        color: theme.palette.grey[100]
      },
      "&:active": {
        color: theme.palette.grey[200]
      }
    },
    "&.MuiButton-outlined": {
      "&:disabled": {
        backgroundColor: "transparent",
        color: theme.palette.grey[400]
      }
    },
    "&.MuiButton-contained": {
      "&:disabled": {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.grey[400]
      }
    },
    "&:disabled": {
      pointerEvents: "none"
    }
  })
);
export {
  StyledSquareButton
};
//# sourceMappingURL=styles.js.map
